import React, { useState, useEffect } from 'react';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import { LogoImage } from '~/shared/components/logoImage';

import {
  Container,
  ForgetPasswordBox,
  ImageContainer,
  Form,
  FormContainer,
  InputContainer,
  Think,
  Input,
  InputError,
  Button,
  MustContain,
  ContainTitle,
  UpperSubtitle,
  NumberSubtitle,
  MinSubtitle,
  CharSubtitle,
  Title,
} from './styles';

const ResetPassword = () => {
  const [upperValidate, setupperValidate] = useState(false);
  const [numberValidate, setnumberValidate] = useState(false);
  const [minValidate, setminValidate] = useState(false);
  const [charValidate, setcharValidate] = useState(false);
  const [passwordData, setpasswordData] = useState([]);
  const [compareSuccess, setcompareSuccess] = useState(true);

  const contain = {
    title: 'Sua senha deve conter:',
    firstSubTitle: 'Pelo menos uma letra maiúscula (A-Z)',
    secondSubTitle: 'Pelo menos um número (0-9)',
    thirdSubTitle: 'Mínimo de 8 caracteres',
    fourSubTitle: 'Pelo menos um caracter especial (!@$&)',
  };

  useEffect(() => {
    setpasswordData(['Igo180492@']);
  }, [setpasswordData]);

  const comparePassword = (value, password) => {
    if (value === password) {
      setcompareSuccess(false);
      return false;
    }
    setcompareSuccess(true);
    return true;
  };

  const formik = useFormik({
    initialValues: {
      newPassword: '',
      confirmPassword: '',
    },
    validationSchema: Yup.object({
      newPassword: Yup.string()
        .matches(
          /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
          'Validar requirimentos mínimos'
        )
        .required('Campo Obrigatório')
        .test(
          'Equal_values',
          'Senha igual senha antiga',
          (value) => value && comparePassword(value, passwordData)
        ),

      confirmPassword: Yup.string()
        .required('Campo Obrigatório')
        .oneOf([Yup.ref('newPassword'), null], 'Esta senha não corresponde'),
    }),

    onSubmit: (values, { resetForm }) => {
      // setSubmitting(false);
      resetForm(formik.initialValues);
      if (compareSuccess) {
        return values;
      }
    },
  });

  const upperTest = (value) => {
    const regex = /^(?=.*[A-Z])/;
    const test = regex.test(value);

    setupperValidate(test);
  };

  const numberTest = (value) => {
    const regex = /[0-9]/;
    const test = regex.test(value);

    setnumberValidate(test);
  };

  const minTest = (value) => {
    const regex = /^.{8,}$/;
    const test = regex.test(value);

    setminValidate(test);
  };

  const chatTest = (value) => {
    const regex = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
    const test = regex.test(value);

    setcharValidate(test);
  };

  const validateInput = (value) => {
    upperTest(value);
    numberTest(value);
    minTest(value);
    chatTest(value);
  };

  return (
    <Container>
      <ForgetPasswordBox>
        <ImageContainer>
          <LogoImage />
        </ImageContainer>
        <Title>Redefinição de senha.</Title>
        <Form onSubmit={formik.handleSubmit}>
          <FormContainer>
            <InputContainer>
              <Think htmlFor="password">Nova Senha:</Think>
              <Input
                {...formik.getFieldProps('newPassword')}
                id="newPassword"
                name="newPassword"
                type="password"
                onChange={formik.handleChange}
                onKeyUp={(event) => validateInput(event.target.value)}
                value={formik.values.newPassword}
                error={
                  !!(formik.touched.newPassword && formik.errors.newPassword)
                }
                helperText
              />
              <InputError>
                {formik.touched.newPassword && formik.errors.newPassword
                  ? formik.errors.newPassword
                  : null}
              </InputError>
            </InputContainer>
            <InputContainer>
              <Think htmlFor="password">Confirmar Senha:</Think>
              <Input
                {...formik.getFieldProps('confirmPassword')}
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                onChange={formik.handleChange}
                value={formik.values.confirmPassword}
                error={
                  !!(
                    formik.touched.confirmPassword &&
                    formik.errors.confirmPassword
                  )
                }
                helperText={
                  formik.touched.confirmPassword &&
                  formik.errors.confirmPassword
                    ? formik.errors.confirmPassword
                    : null
                }
              />
              <InputError>
                {formik.touched.confirmPassword && formik.errors.confirmPassword
                  ? formik.errors.confirmPassword
                  : null}
              </InputError>
            </InputContainer>
            <Button type="submit">Alterar senha</Button>
          </FormContainer>
        </Form>

        <MustContain>
          <ContainTitle>{contain.title}</ContainTitle>
          <UpperSubtitle upperTest={upperValidate}>
            {contain.firstSubTitle}
          </UpperSubtitle>
          <NumberSubtitle numberTest={numberValidate}>
            {contain.secondSubTitle}
          </NumberSubtitle>
          <MinSubtitle minTest={minValidate}>
            {contain.thirdSubTitle}
          </MinSubtitle>
          <CharSubtitle charTest={charValidate}>
            {contain.fourSubTitle}
          </CharSubtitle>
        </MustContain>
      </ForgetPasswordBox>
    </Container>
  );
};

export default ResetPassword;
